import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginService } from "../../../services/oauth/login.service";
import { PkceService } from "../../../services/oauth/pkce.service";
import { AUTH_CONSTANTS } from '../../../shared/constants/auth.constants';

@Component({
    selector: 'logout',
    template: ''
})

export class LogoutComponent  {

	constructor(private loginService: LoginService, private pkceService: PkceService) {

		var win = window.open(environment.auth.url + AUTH_CONSTANTS.URL_PATH_LOGOUT);
		win.focus();
		setTimeout(async () => {
			win.close();
			this.loginService.clearSession();

			try {
				const codeVerifier = this.pkceService.generateCodeVerifier();
				const codeChallenge = await this.pkceService.generateCodeChallenge(codeVerifier);
				
				this.pkceService.storePkceValues(codeVerifier, codeChallenge);
								const authUrl = new URL(environment.auth.url + AUTH_CONSTANTS.URL_PATH_AUTHORIZE);
				authUrl.searchParams.append('client_id', environment.auth.client_id);
				authUrl.searchParams.append('scope', environment.auth.scope);
				authUrl.searchParams.append('response_type', AUTH_CONSTANTS.RESPONSE_TYPE);
				authUrl.searchParams.append('redirect_uri', environment.auth.redirect_uri);
				authUrl.searchParams.append('response_mode', AUTH_CONSTANTS.RESPONSE_MODE);
				authUrl.searchParams.append('code_challenge', codeChallenge);
				authUrl.searchParams.append('code_challenge_method', AUTH_CONSTANTS.CODE_CHALLENGE_METHOD);
				authUrl.searchParams.append('prompt', 'select_account');
				
				window.location.href = authUrl.toString();

			} catch (error) {
				console.error('Error generating PKCE values:', error);
				const authUrl = new URL(environment.auth.url + AUTH_CONSTANTS.URL_PATH_AUTHORIZE);
				authUrl.searchParams.append('client_id', environment.auth.client_id);
				authUrl.searchParams.append('scope', environment.auth.scope);
				authUrl.searchParams.append('response_type', AUTH_CONSTANTS.RESPONSE_TYPE);
				authUrl.searchParams.append('redirect_uri', environment.auth.redirect_uri);
				authUrl.searchParams.append('response_mode', AUTH_CONSTANTS.RESPONSE_MODE);
				authUrl.searchParams.append('prompt', 'select_account');
				
				window.location.href = authUrl.toString();
			}
		}, 1500);
	}
}

